import React from 'react';
import { ELECTRONIC_WASTE, NO_VEHICLE } from 'constants/icons';
import ElectronicWasteInfoBackground from './ElectronicWasteInfoBackground';
import NoVehicle from '../VehicleIcon/NoVehicle';
const Icon = props => {
  switch (props.name) {
    case ELECTRONIC_WASTE:
      return /*#__PURE__*/React.createElement(ElectronicWasteInfoBackground, props);
    case NO_VEHICLE:
      return /*#__PURE__*/React.createElement(NoVehicle, props);
    default:
      return /*#__PURE__*/React.createElement("div", null);
  }
};
export default Icon;